import { useState } from "react";
import { CharterStudio } from "./CharterStudio";

type RelayAdminModule = "landing" | "charter-studio";

/**
 * track:relay-admin-charter-studio (backlog #41143) — founder-only nav
 * section, Charter Studio is the first module.
 *
 * Independent re-check of founder identity, not just a UI-layer nice-to-
 * have: App.tsx's SidebarNavRow gate only controls whether the nav
 * *entry* renders, not whether this view can be reached (setCenterView
 * is plain component state — anything that can call it, or restore a
 * stale centerView, could land here without going through the nav row).
 * This component treats `isFounder` as untrusted the moment it's passed
 * in and refuses to render its children without it. The actual
 * authorization boundary for the one action that matters (writing the
 * Charter) is still server-side (PLATFORM_OWNER_UID, /api/charter) —
 * this check exists so a non-founder never even sees the editor UI, not
 * because the server trusts it.
 */
export function RelayAdmin({ isFounder, workspaceId }: { isFounder: boolean; workspaceId?: string }) {
  const [module, setModule] = useState<RelayAdminModule>("landing");

  if (!isFounder) {
    return (
      <div style={{ padding: 24, color: "var(--text3)", fontSize: 13 }}>
        Relay Admin is restricted to the platform owner.
      </div>
    );
  }

  if (module === "charter-studio") {
    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <div style={{ padding: "10px 24px", borderBottom: "1px solid #5FC4C033", flexShrink: 0 }}>
          <button
            onClick={() => setModule("landing")}
            style={{
              background: "none",
              border: "none",
              color: "var(--er-accent)",
              cursor: "pointer",
              fontSize: 12,
              padding: 0,
            }}
          >
            ← Relay Admin
          </button>
        </div>
        <div style={{ flex: 1, minHeight: 0 }}>
          <CharterStudio workspaceId={workspaceId} />
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ fontSize: 15, fontWeight: 600, color: "var(--text)", marginBottom: 16 }}>Relay Admin</div>
      <button
        onClick={() => setModule("charter-studio")}
        style={{
          display: "block",
          width: "100%",
          maxWidth: 320,
          textAlign: "left",
          padding: 16,
          background: "var(--surface)",
          border: "1px solid var(--border)",
          borderRadius: 8,
          cursor: "pointer",
        }}
      >
        <div style={{ fontSize: 13.5, fontWeight: 600, color: "var(--text)", marginBottom: 4 }}>Charter Studio</div>
        <div style={{ fontSize: 12, color: "var(--text3)" }}>Edit the live platform Charter directly.</div>
      </button>
    </div>
  );
}
